import React from "react";
import { Button } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import { colors } from "~/utils/colors";

const useStyles = makeStyles(() => ({
	root: {
		backgroundColor: colors?.brand?.dark,
		color: "#fff",
		textTransform: "none",
		borderRadius: 24,
		height: 48,
		fontSize: 16,
		fontWeight: 500,
		"&:hover": {
			backgroundColor: colors?.brand?.dark,
		},
	},
}));

const ButtonDefault = ({ children, onClick, fullWidth = true, ...props }) => {
	const classes = useStyles();

	return (
		<Button
			onClick={onClick}
			fullWidth={fullWidth}
			className={classes.root}
			{...props}
		>
			{children}
		</Button>
	);
};

export default ButtonDefault;
